/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Image } from './Image';
import {
    ImageFromJSON,
    ImageFromJSONTyped,
    ImageToJSON,
} from './Image';

/**
 * Representation of a Variant Option Qualifier
 * @export
 * @interface VariantOptionQualifier
 */
export interface VariantOptionQualifier {
    /**
     * Qualifier
     * @type {string}
     * @memberof VariantOptionQualifier
     */
    qualifier?: string;
    /**
     * Name of variant option qualifier
     * @type {string}
     * @memberof VariantOptionQualifier
     */
    name?: string;
    /**
     * Value of variant option qualifier
     * @type {string}
     * @memberof VariantOptionQualifier
     */
    value?: string;
    /**
     * 
     * @type {Image}
     * @memberof VariantOptionQualifier
     */
    image?: Image;
}

/**
 * Check if a given object implements the VariantOptionQualifier interface.
 */
export function instanceOfVariantOptionQualifier(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function VariantOptionQualifierFromJSON(json: any): VariantOptionQualifier {
    return VariantOptionQualifierFromJSONTyped(json, false);
}

export function VariantOptionQualifierFromJSONTyped(json: any, ignoreDiscriminator: boolean): VariantOptionQualifier {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'qualifier': !exists(json, 'qualifier') ? undefined : json['qualifier'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'value': !exists(json, 'value') ? undefined : json['value'],
        'image': !exists(json, 'image') ? undefined : ImageFromJSON(json['image']),
    };
}

export function VariantOptionQualifierToJSON(value?: VariantOptionQualifier | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'qualifier': value.qualifier,
        'name': value.name,
        'value': value.value,
        'image': ImageToJSON(value.image),
    };
}

